import { useCallback, useContext } from "react";
import useTranslate from "hooks/useTranslate";
import MessageDialogContext from "context/MessageDialogContext";
import { IsSyrianTaxEnable } from "helpers/TaxSystemHelper";

export default function usePrintDesignMissingMandatoryDialog() {
  const { translate } = useTranslate("admin.print");
  const isSyrianTaxEnabled = IsSyrianTaxEnable();
  const { setActionCloseMessageInfo } = useContext(MessageDialogContext);

  return useCallback(() => {
    setActionCloseMessageInfo(
      translate("missingRequiredFieldsTitle"),
      translate(
        isSyrianTaxEnabled
          ? "printDesignMissingMandatoryPlaceholdersSYRTaxes"
          : "printDesignMissingMandatoryPlaceholders",
      ),
      "close",
    );
  }, [setActionCloseMessageInfo, translate]);
}
